import { BooleanInput, coerceBooleanProperty } from '@angular/cdk/coercion';
import {
  AfterViewInit,
  computed,
  Directive,
  Input,
  Output,
} from '@angular/core';
import { Select } from 'primeng/select';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

@Directive({
  standalone: true,
  selector: '[appDropdownExtender]p-select',
})
/** Directive used with PrimeNG dropdown, to support server side filtering */
export class DropdownExtenderDirective implements AfterViewInit {
  @Input() filterDebounceTime = 300;

  @Input('appDropdownExtender')
  set enabled(value: BooleanInput) {
    this._enabled = coerceBooleanProperty(value);
  }
  get enabled(): boolean {
    return this._enabled;
  }
  private _enabled = true;

  private _onFilter = new Subject<string>();
  @Output() onFilter = this._onFilter.pipe(
    debounceTime(this.filterDebounceTime),
    distinctUntilChanged(),
  );

  constructor(private pDropdown: Select) {}

  ngAfterViewInit() {
    // Override primeNG dropdown's onFilterInputChange method to support server side filtering.
    setTimeout(() => {
      if (this.enabled) {
        this.pDropdown.filter = true;
        this.pDropdown.onFilterInputChange = (event) => {
          const inputValue = event.target.value;
          this.pDropdown._filterValue.set(inputValue);
          this._onFilter.next(inputValue);

          this.pDropdown.optionsChanged = true;
        };
        this.pDropdown.visibleOptions = computed(() => {
          return this.pDropdown.group
            ? this.pDropdown.flatOptions(this.pDropdown.options)
            : this.pDropdown.options || [];
        });
        if (this.pDropdown.options && this.pDropdown.options.length)
          this.pDropdown.optionsChanged = true;
      }
    });
  }
}
